import { IDataList } from 'redux-store/types';
import { SelectionStatusEnum } from '../selections';

export enum HashtagMentionTypeEnum {
  phaseItem = 'PHASE_ITEM',
  fileCabinetItem = 'FILE_CABINET_ITEM',
  selection = 'SELECTION',
  selectionOption = 'SELECTION_OPTION',
}

export interface IHashtagMentionBase {
  id: number;
  name: string;
  type: HashtagMentionTypeEnum;
  mimeType?: string;
  selectionItemId?: number;
  hasAccess?: boolean;
}

export interface IHashtagMentionFile extends IHashtagMentionBase {
  mimeType: string;
  type: HashtagMentionTypeEnum.fileCabinetItem;
}

export interface IHashtagMentionPhase extends IHashtagMentionBase {
  type: HashtagMentionTypeEnum.phaseItem;
}

export interface IHashtagMentionSelectionOption extends IHashtagMentionBase {
  type: HashtagMentionTypeEnum.selectionOption;
  selectionItemId: number;
}

export interface IHashtagMentionSelection extends IHashtagMentionBase {
  type: HashtagMentionTypeEnum.selection;
}

export type IHashtagMention =
  | IHashtagMentionFile
  | IHashtagMentionPhase
  | IHashtagMentionSelectionOption
  | IHashtagMentionSelection;

////////////////////////////////////////////////////////////////////////////////

export interface IGetHashtagSuggestionsArgs {
  projectId: number;
  search: string;
}

export type IGetHashtagSuggestions = IDataList<IGetHashtagSuggestion>;

export interface IGetFileCabinetItemHashtagSuggestion {
  type: HashtagMentionTypeEnum.fileCabinetItem;
  id: number;
  name: string;
  size: string;
  mimeType: string;
  path: string;
  fileCabinetPath: string;
  hasAccess?: boolean;
}

export interface IGetPhaseItemHashtagSuggestion {
  type: HashtagMentionTypeEnum.phaseItem;
  id: number;
  title: string;
  phaseId: number;
  isCompleted: boolean;
  workDays: number;
  startDate: string;
  endDate: string;
  hasAccess?: boolean;
}

export interface IGetSelectionHashtagSuggestion {
  type: HashtagMentionTypeEnum.selection;
  id: number;
  title: string;
  costCodeId: number;
  status: SelectionStatusEnum;
  hasAccess?: boolean;
}

export interface IGetSelectionOptionHashtagSuggestion {
  type: HashtagMentionTypeEnum.selectionOption;
  id: number;
  title: string;
  selectionItemId: number;
  hasAccess?: boolean;
}

export type IGetHashtagSuggestion =
  | IGetFileCabinetItemHashtagSuggestion
  | IGetPhaseItemHashtagSuggestion
  | IGetSelectionHashtagSuggestion
  | IGetSelectionOptionHashtagSuggestion;

////////////////////////////////////////////////////////////////////////////////

export interface IGetActivityFeedHashtagBase {
  length: number;
  offset: number;
  block: number;
  key: number;
  type: HashtagMentionTypeEnum;
}

export interface IGetActivityFeedFileCabinetHashtag extends IGetActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.fileCabinetItem;
  fileCabinet: {
    id: number;
    name: string;
    mimeType: string;
  };
}

export interface IGetActivityFeedPhaseItemHashtag extends IGetActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.phaseItem;
  phaseItem: {
    id: number;
    title: string;
  };
}

export interface IGetActivityFeedSelectionHashtag extends IGetActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.selection;
  selection: {
    id: number;
    title: string;
  };
}

export interface IGetActivityFeedSelectionOptionHashtag extends IGetActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.selectionOption;
  selectionOption: {
    id: number;
    selectionItemId: number;
    title: string;
  };
}

export type IGetActivityFeedHashtag =
  | IGetActivityFeedFileCabinetHashtag
  | IGetActivityFeedPhaseItemHashtag
  | IGetActivityFeedSelectionHashtag
  | IGetActivityFeedSelectionOptionHashtag;

////////////////////////////////////////////////////////////////////////////////

export interface ICreateActivityFeedHashtagBase {
  offset: number;
  length: number;
  block: number;
  key: number;
}

export interface ICreateActivityFeedPhaseItemHashtag extends ICreateActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.phaseItem;
  phaseItemId: number | null;
}

export interface ICreateActivityFeedFileCabinetHashtag extends ICreateActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.fileCabinetItem;
  fileCabinetId: number | null;
}

export interface ICreateActivityFeedSelectionHashtag extends ICreateActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.selection;
  selectionId: number | null;
}

export interface ICreateActivityFeedSelectionOptionHashtag extends ICreateActivityFeedHashtagBase {
  type: HashtagMentionTypeEnum.selectionOption;
  selectionOptionId: number | null;
}

export type ICreateActivityFeedHashtag =
  | ICreateActivityFeedPhaseItemHashtag
  | ICreateActivityFeedFileCabinetHashtag
  | ICreateActivityFeedSelectionHashtag
  | ICreateActivityFeedSelectionOptionHashtag;
